import { restClient } from '../../core/network/restClient';
import { toBeDemand, toBeReason } from './complainEnums';

// Cùng một path cho cả xem (GET) lẫn gửi (POST). Lỗi cứ ném RestError lên, như apiAdapters của orderTracking.
const PUBLIC_COMPLAIN_PATH = '/api/v1/public/order-tracking/complain';

export const fetchPublicComplain = async ({ orderCode, phoneNumber } = {}, { signal } = {}) => {
  const { data } = await restClient.get(PUBLIC_COMPLAIN_PATH, {
    params: { order_code: orderCode, phone_number: phoneNumber },
    signal,
  });
  return data;
};

export const createPublicComplain = async ({
  orderCode,
  phoneNumber,
  productIds,
  reason,
  demand,
  description,
  total,
  paymentMethod,
  attachmentUrls,
}) => {
  // reason/demand có giá trị 0 là LOW_QUANTITY/SWAP: gửi thiếu thì proto tự hiểu là 0 và khiếu nại lọt qua
  // với lựa chọn khách không hề chọn. Chặn ở đây thay vì tin vào validate của form.
  if (!reason || !demand) throw new Error('Thiếu lý do hoặc yêu cầu khiếu nại');

  const { data } = await restClient.post(PUBLIC_COMPLAIN_PATH, {
    orderCode,
    phoneNumber,
    productIds,
    reason: toBeReason(reason),
    demand: toBeDemand(demand),
    description,
    total,
    paymentMethod,
    attachmentUrls,
  });
  return data;
};
